const PageDots = ({ currentPage, totalPages }) => {
    const dots = [];
    for (let i = 0; i < totalPages; i++) {
      dots.push(
        <span
          key={i}
          className={`dot ${i === currentPage ? "active" : ""}`}
        ></span>
      );
    }
  
    return <div className="page-dots">{dots}</div>;
  };
  
  export default PageDots;
  